var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle2, _circle3, _path11, _path12, _path13, _path14, _path15, _circle4, _path16, _path17, _path18, _path19, _path20, _circle5, _path21, _path22, _path23, _path24, _path25, _circle6, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultoGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#30D8A7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.783 12.1172C18.3624 12.1172 18.0234 12.4895 18.0234 12.9529V27.0496C18.0234 27.5121 18.3624 27.8853 18.783 27.8853H29.6266C30.0472 27.8853 30.3862 27.5121 30.3862 27.0496V12.9529C30.3862 12.4895 30.0472 12.1172 29.6266 12.1172H18.783ZM18.6308 12.8096H29.7724V27.1849H18.6308V12.8096Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2329 14.2031H24.9219V15.9909H28.2329V14.2031Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2173 14.2031H20.9062V15.9909H24.2173V14.2031Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2329 16.6328H24.9219V18.4206H28.2329V16.6328Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2173 16.6328H20.9062V18.4206H24.2173V16.6328Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2329 19.125H24.9219V20.9128H28.2329V19.125Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2173 19.125H20.9062V20.9128H24.2173V19.125Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2329 21.6172H24.9219V23.405H28.2329V21.6172Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2173 21.6172H20.9062V23.405H24.2173V21.6172Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2329 24.0781H24.9219V25.8659H28.2329V24.0781Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2173 24.0781H20.9062V25.8659H24.2173V24.0781Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4297 29.8047L9.61719 27.8438V12.1631L21.4297 10.2031V29.8047ZM16.1982 16.6279L15.2285 18.8701C15.1686 19.0327 15.1471 19.1152 15.1533 19.2207C15.1397 19.13 15.1126 18.9955 15.0537 18.8701L14.2354 16.7441L12.8545 16.8262L14.2871 20.0674L12.6953 23.2988L14.0723 23.3809L15.0537 21.1045C15.0945 20.9936 15.0974 20.9432 15.1045 20.8818C15.1198 20.968 15.1046 20.9922 15.1807 21.168L16.1562 23.5049L17.7617 23.6006L15.9482 20.0195C16.5047 18.8479 17.0845 17.6874 17.6875 16.5391L16.1982 16.6279Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#30D8A7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1883,
    cy: 11.0555,
    r: 3.65706,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9111 16.9971H21.4824V15.9707C24.657 16.9479 26.9648 19.9043 26.9648 23.3994V24.54C26.9648 25.2746 26.4705 25.9165 25.7549 26.082C24.1138 26.4613 21.139 27.0686 18.9775 27.0557C16.9558 27.0436 14.1849 26.4596 12.6221 26.0879C11.9107 25.9187 11.4219 25.279 11.4219 24.5479V23.3994C11.4219 19.9017 13.7329 16.9437 16.9111 15.9688V16.9971Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3672 23.4971L18.3424 18.8203H20.049L21.0242 23.7433L19.3176 25.2202L17.3672 23.4971Z",
    fill: "white",
    stroke: "#30D8A7",
    strokeWidth: 0.890529,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3672 17.4609L18.1508 19.2895H20.2406L21.0242 17.4609H17.3672Z",
    fill: "white",
    stroke: "#30D8A7",
    strokeWidth: 0.890529,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9082 19.2801L15.5703 17.0458L17.8225 15.8516L19.1939 17.4515L16.9082 19.2801Z",
    fill: "white",
    stroke: "#30D8A7",
    strokeWidth: 0.890529,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4788 19.2801L22.7344 16.9961L20.5645 15.8516L19.1932 17.4515L21.4788 19.2801Z",
    fill: "white",
    stroke: "#30D8A7",
    strokeWidth: 0.890529,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.3004,
    cy: 14.7066,
    r: 2.82383,
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0713 18.5C15.5234 19.254 17.3057 21.5369 17.3057 24.2363V25.1172C17.3057 25.6843 16.9245 26.1797 16.3721 26.3076C15.1048 26.6004 12.8077 27.0695 11.1387 27.0596C9.57761 27.0502 7.43825 26.5995 6.23145 26.3125C5.68217 26.1819 5.30469 25.6876 5.30469 25.123V24.2363C5.30469 21.536 7.08861 19.2533 9.54199 18.5V19.293H13.0713V18.5Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89062 24.3144L10.6436 20.7031H11.9614L12.7145 24.5044L11.3967 25.6448L9.89062 24.3144Z",
    fill: "white",
    stroke: "#30D8A7",
    strokeWidth: 0.890529,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89062 19.6562L10.4957 21.0682H12.1093L12.7145 19.6562H9.89062Z",
    fill: "white",
    stroke: "#30D8A7",
    strokeWidth: 0.890529,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54088 21.0536L8.50781 19.3284L10.2468 18.4062L11.3058 19.6417L9.54088 21.0536Z",
    fill: "white",
    stroke: "#30D8A7",
    strokeWidth: 0.890529,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0774 21.0536L14.0469 19.29L12.3714 18.4062L11.3125 19.6417L13.0774 21.0536Z",
    fill: "white",
    stroke: "#30D8A7",
    strokeWidth: 0.890529,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.6754,
    cy: 15.2379,
    r: 2.82383,
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4463 19.0312C31.8984 19.7853 33.6807 22.0682 33.6807 24.7676V25.6484C33.6807 26.2156 33.2995 26.711 32.7471 26.8389C31.4798 27.1317 29.1827 27.6008 27.5137 27.5908C25.9526 27.5815 23.8132 27.1308 22.6064 26.8438C22.0572 26.7131 21.6797 26.2189 21.6797 25.6543V24.7676C21.6797 22.0673 23.4636 19.7845 25.917 19.0312V19.8242H29.4463V19.0312Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2656 24.8456L27.0186 21.2344H28.3364L29.0895 25.0357L27.7717 26.1761L26.2656 24.8456Z",
    fill: "white",
    stroke: "#30D8A7",
    strokeWidth: 0.890529,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2656 20.1875L26.8707 21.5994H28.4843L29.0895 20.1875H26.2656Z",
    fill: "white",
    stroke: "#30D8A7",
    strokeWidth: 0.890529,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9159 21.5848L24.8828 19.8596L26.6218 18.9375L27.6808 20.1729L25.9159 21.5848Z",
    fill: "white",
    stroke: "#30D8A7",
    strokeWidth: 0.890529,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4524 21.5848L30.4219 19.8212L28.7464 18.9375L27.6875 20.1729L29.4524 21.5848Z",
    fill: "white",
    stroke: "#30D8A7",
    strokeWidth: 0.890529,
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.6776,
    cy: 25.5448,
    r: 6.43546,
    fill: "white",
    stroke: "#30D8A7",
    strokeWidth: 0.890529
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1172 25.5484C24.1172 25.1549 24.4362 24.8359 24.8296 24.8359H30.529C30.9225 24.8359 31.2414 25.1549 31.2414 25.5484C31.2414 25.9418 30.9225 26.2608 30.529 26.2608H24.8296C24.4361 26.2608 24.1172 25.9418 24.1172 25.5484Z",
    fill: "#30D8A7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6812 29.1094C27.2877 29.1094 26.9688 28.7904 26.9688 28.397V22.6976C26.9688 22.3041 27.2877 21.9851 27.6812 21.9851C28.0746 21.9851 28.3936 22.3041 28.3936 22.6976V28.397C28.3936 28.7904 28.0746 29.1094 27.6812 29.1094Z",
    fill: "#30D8A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultoGroup);
export default __webpack_public_path__ + "static/media/multoGroup.2c99f4ea928a6b3178389793ee221709.svg";
export { ForwardRef as ReactComponent };